import {Component} from '@angular/core';


@Component({
    selector: 'app-repository-policy-termination-aside',
    templateUrl: './repository-policy-termination-aside.component.html',
})
export class RepositoryPolicyTerminationAsideComponent {

}
